import * as React from 'react';

import {PopoverInfo} from 'shells/popover-info/popover-info';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {EngagementStats} from 'nutshell-graphql-types';

import {EngagementStatsBlock} from './engagement-stats-block';

type Props = {
    engagementStats: EngagementStats | null | undefined;
    isLoading: boolean;
    onClickStat?: (filterKey: string) => string;
    label?: string;
    infoText?: string;
};

export function EngagementBar(props: Props) {
    return (
        <div>
            <div className='mb-8'>
                <div className='flex align-center'>
                    <UppercaseLabel>{props.label || 'Totals'}</UppercaseLabel>
                    {props.infoText ? (
                        <PopoverInfo size={14} bodyColor='dark' info={props.infoText} />
                    ) : undefined}
                </div>
            </div>
            <EngagementStatsBlock
                isLoading={props.isLoading}
                includeHelp={true}
                stats={props.engagementStats}
                includeBounceRate={true}
                onClickStat={props.onClickStat}
            />
        </div>
    );
}
